import { MessageCode } from '../shared/error/user-message';

export class ErrorDisplayData {
  public message: string;
  public error?: any;
  public messageCode?: MessageCode;

  constructor(message: string, error?: any, messageCode?: MessageCode) {
    this.message = message;
    this.error = error;
    this.messageCode = messageCode;
  }
}
